import { render, staticRenderFns } from "./checkout.vue?vue&type=template&id=7a147a16&scoped=true&"
import script from "./checkout.vue?vue&type=script&lang=js&"
export * from "./checkout.vue?vue&type=script&lang=js&"
import style0 from "./checkout.vue?vue&type=style&index=0&id=7a147a16&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a147a16",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Checkout: require('/app/components/checkout/index.vue').default})
